'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'redux-actions';
import { REQUESTED_DATA_CHECK, RECEIVED_DATA_CHECK, REPORT_RESOLVED } from '../constants/actionTypes';
import requestStatusType from '../../constants/requestStatusTypes';
const initialState = ImmutableMap();
export default handleActions({
  [REQUESTED_DATA_CHECK](state, {
    payload
  }) {
    return state.mergeIn([payload], {
      status: requestStatusType.PENDING,
      hasData: null
    });
  },
  [RECEIVED_DATA_CHECK](state, {
    payload
  }) {
    const {
      appKey,
      hasData
    } = payload;
    return state.mergeIn([appKey], {
      status: requestStatusType.SUCCEEDED,
      hasData
    });
  },
  [REPORT_RESOLVED](state, {
    payload
  }) {
    const {
      appKey,
      hasData
    } = payload;
    return state.setIn([appKey, 'reportHasData'], hasData);
  }
}, initialState);